import { Table, TableBody, TableHead, TableRow } from '@mui/material'
import HFCard from '../../../../components/HFCard'
import { StyledTableCell, StyledTableRow } from '../../../../components/Table.styled'
import { AnnualReport } from '../types'
import { downloadReport } from '../service'
import { downloadFile } from '../../../../helpers/downloadFile'
import { useState } from 'react'
import { TableButton } from '../../../../components/Buttons.styled'
import { Download as DownloadIcon } from '@mui/icons-material'
import { useAppDispatch } from '../../../../redux/store'
import { addError } from '../../../../redux/alerts'

interface AnnualReportsTableProps {
  customerNumber: string
  annualReports: AnnualReport[]
}

const AnnualReportsTable = ({ customerNumber, annualReports }: AnnualReportsTableProps) => {
  const dispatch = useAppDispatch()
  const [downloadingReport, setDownloadingReport] = useState<number | null>(null)

  const handleDownload = async (report: AnnualReport) => {
    setDownloadingReport(report.year)
    try {
      const options = {
        fromDate: `01/01/${String(report.year).slice(-2)}`,
        toDate: `12/31/${String(report.year).slice(-2)}`
      }
      const blob = await downloadReport(customerNumber, options)
      const url = URL.createObjectURL(blob)
      const fileName = 'annual_report.pdf'
      await downloadFile({ url, fileName, isBlobURL: true })
    } catch (error) {
      console.error(error)
      dispatch(addError('There was a problem downloading this report'))
    }
    setDownloadingReport(null)
  }

  return (
    <HFCard headerText='Biological Monitoring Annual Reports'>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <StyledTableCell>Download</StyledTableCell>
            <StyledTableCell>Report Type</StyledTableCell>
            <StyledTableCell>Year</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {annualReports?.map(report => (
            <StyledTableRow key={report.year}>
              <StyledTableCell>
                <TableButton
                  startIcon={<DownloadIcon/>}
                  variant='contained'
                  size='small'
                  disabled={report.year === downloadingReport}
                  onClick={() => handleDownload(report)}
                >
                  {report.year !== downloadingReport ? 'Download' : 'Downloading...'}
                </TableButton>
              </StyledTableCell>
              <StyledTableCell>Biological Monitoring</StyledTableCell>
              <StyledTableCell>{report.year}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </HFCard>
  )
}

export default AnnualReportsTable